import styled from 'styled-components';
import { Loading } from 'components/Loading';

const EmptyListStyled = styled.div`
  text-align: center;
`;

const LoadingListStyled = styled(Loading)`
  margin: 30px auto 30px auto;
`;

export { EmptyListStyled, LoadingListStyled };
